module.exports = __webpack_public_path__ + "static/media/36-iveco.1f7e0ada.jpg";